import React from "react";

const HomeBanner = ({ masterConfigKey }) => {
  return (
    <div>
      {masterConfigKey && (
        <a
          href={
            masterConfigKey?.homeBannerRedirectUrl || "/bihar/bihar-tak-baithak"
          }
        >
          {/* Desktop Banner: visible on md and up */}
          <img
            src={masterConfigKey?.desktopBannerUrlHome_Cat}
            alt="sponsor"
            className="hidden md:block w-full h-full "
          />

          {/* Mobile Banner: visible below md */}
          <img
            src={masterConfigKey?.mobileBannerUrlHome_Cat}
            alt="sponsor"
            className="block md:hidden w-full h-full"
          />
        </a>
      )}
    </div>
  );
};

export default HomeBanner;
